export default __webpack_public_path__ + "static/media/drive_logo.f2ae30d1.svg";